export const gallery = [
  '/images/generalimg/home_page_row/RREF.webp',
  '/images/generalimg/home_page_row/schoolofart.webp',
  '/images/generalimg/home_page_row/greeceolymp.webp',
  '/images/generalimg/home_page_row/img4.webp',
];

export const alumni = [
  {
    name: 'Michael Christof',
    positions: ['President (2024)', 'Vice President (2023 - 2024)'],
  },
  {
    name: 'Nancy Fan',
    positions: ['Dir. of Outreach (2024)'],
  },
  {
    name: 'Smit Kothari',
    positions: ['Dir. of Finances (2024)'],
  },
  {
    name: 'Adarsh Mavatheveedu',
    positions: ['President (2022 - 2023)', 'Dir. of Outreach (2023 - 2024)',]
  },
  {
    name: 'Krish Patel',
    text: "",
    image: '/images/profileimg/national/krishpatel.webp',
    positions: ['Nat\'l Board (2024 - )'],
  },
  {
    name: 'Mihika Biswas',
    text: "I am Mihika Biswas and I'm a sophomore in the 8-year BS/MD program at the University of Rochester. As someone who was heavily involved in the college admissions process, I know how it can feel overwhelming to navigate everything on your own. Given that I received so much help and guidance from older students during my college application process, I'm thrilled to be part of Project LTF and pass on some of that same guidance to current high school students. I'm excited to help students get to college and hopefully see some of them here at the University of Rochester!",
    image: '/images/profileimg/rochester/mihikabiswas.webp',
    positions: ['Roc: Dir. of Operations (2024 - )'],
  },
  {
    name: 'Valerie Voytsekhovskaya',
    text: "As a student who had minimal resources, I'm forever grateful to the people who volunteered their time and knowledge to mentor me in my application cycle. I firsthandly know how life changing good mentorship can be- from offering the right advice to just alleviating the emotional burden of a process that can feel very daunting. At Project LTF, it's a great joy to partake in helping students take their next steps towards their future. Beyond LTF, I'm a current Junior in the BS/MD program and doing stem cell research. I also love the greater outdoors, making puzzles with friends, and baking cookies!",
    image: '/images/profileimg/national/ValerieVoytsekhovskaya.webp',
    positions: ['Nat\'l Board (2022 - )', 'Roc: Vice President (2024 - )', 'Roc: Dir. of Mentorship (2023 - 2024)'],
  },
  {
    name: 'Keira Donnelly',
    text: "I'm Keira Donnelly, a junior at the University of Rochester studying neuroscience and psychology on the pre-med track. Growing up, my mom, who worked in the Rochester City School District, instilled in me the importance of accessible, quality education for all students. This passion led me to co-found Project Level the Field, an organization that helps low-income students navigate the college application process. As a high school student, I struggled with the application process and lacked guidance. Now, I'm excited to use my experience to support others in the same way I once needed.",
    image: '/images/profileimg/national/keiradonnel.webp',
    positions: ['Co-Founder', 'Nat\'l Board (2022 - )', 'Roc: Dir. of Mentorship (2022 - )'],
  },
  {
    name: 'Ava Brophy',
    text: "Hi my name is Ava and I'm a junior at the University of Rochester! In high school, the idea of college was very intimidating to me. I avoided considering universities and the overall unknowns of life beyond my small town. However, looking back on my experience I recognize how valuable, rewarding, and exciting the application process is. I look forward to being a source of advice and encouragement for students. I am thankful for all I have learned throughout my own experiences, and am eager to share my guidance with others!",
    image: '/images/profileimg/rochester/avabrophy.webp',
    positions: ['Nat\'l Marketing Committee Dir. (2024 - )', 'Roc: Dir. of Marketing (2024 - )'],
  },
  {
    name: 'Hana Zhang',
    text: "Hi, I'm Hana, a Public Health major on the pre-med track at the University of Rochester in the Class of 2026. As the oldest daughter in an immigrant family, I navigated the college application process largely on my own, balancing affordability and ambition. Without access to costly services, I spent countless hours researching schools, scholarships, and essays. This inspired me to co-found Project Level the Field, providing free college mentorship to students who need it most. In my free time, I volunteer as an EMT, enjoy watching movies, and love spending time with my Yorkie, Vienna.",
    image: '/images/profileimg/national/hanazhang.webp',
    positions: ['Co-Founder', 'Chief Operating Officer (2022 - )', 'Roc: Executive Advisor (2024 - )', 'Roc: President (2023 - 2024)', 'Roc: Vice President (2022-2023)'],
  },

];

export const leadership = [
  
];

